module.exports = __webpack_public_path__ + "img/szechenyiplus.9ca46270_teszt.a23d732a.png";